import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

/**
 * in this state we're moving all the symbols which stuck in the air to the floor and then
 * throwing new symbols on top
 */
export class AvalancheAddSymbolsState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	protected _isWaitingForAvalancheResponse: boolean = false;

	public onEnterState(): void {
		this.view.fillVoidAfterRemoval();
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(LogicEvents.AVALANCHE_RESPONSE, this.onAvalancheResponse);
		this.on(AvalancheReelsEvents.FILLING_VOIDS_FINISHED, this.onFillingVoidFinished);
		this.on(AvalancheReelsEvents.ADDING_NEW_FINISHED, this.onAddingNewFinished);
	}

	protected onAvalancheResponse(): void {
		if (this._isWaitingForAvalancheResponse) {
			this._isWaitingForAvalancheResponse = false;
			this.onFillingVoidFinished();
		}
	}

	protected onFillingVoidFinished(): void {
		if (this.module.isAvalancheResponseReceived) {
			this.startAddingNewSymbols();
		} else {
			this._isWaitingForAvalancheResponse = true;
		}
	}

	protected onAddingNewFinished(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
		this.emit(AvalancheReelsEvents.AVALANCHE_FINISHED);
	}

	protected startAddingNewSymbols(): void {
		throw new Error('AvalancheAddSymbolsState::startAddingNewSymbols must be overridden');
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheAddSymbolsState.ts